import { CONTRACT_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  contracts: [],
  loading: false,
};

export const contractsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTRACT_ALL_ACTIONS_TYPE.GET_CONTRACTS:
      return {
        ...state,
        contracts: action.payload,
      };
    case CONTRACT_ALL_ACTIONS_TYPE.CONTRACT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case CONTRACT_ALL_ACTIONS_TYPE.CREATE_CONTRACT:
      return {
        ...state,
        contracts: [action.payload, ...state.contracts],
      };
    case CONTRACT_ALL_ACTIONS_TYPE.UPDATE_CONTRACT:
      return {
        ...state,
        contracts: state.contracts.map((contract) =>
          contract._id === action.payload._id ? action.payload : contract,
        ),
      };
    case CONTRACT_ALL_ACTIONS_TYPE.RESET_CONTRACT_PAGINATION:
      return initialState;
    default:
      return state;
  }
};
